(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataDeleteController',ObservedDataDeleteController);

    ObservedDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'ObservedData'];

    function ObservedDataDeleteController($uibModalInstance, entity, ObservedData) {
        var vm = this;

        vm.observedData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ObservedData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
